import { render, staticRenderFns } from "./frtradeprono-add-or-update.vue?vue&type=template&id=cd26fd16"
import script from "./frtradeprono-add-or-update.vue?vue&type=script&lang=js"
export * from "./frtradeprono-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports